import styled from 'styled-components';

export const Label = styled('text')`
  ${({ theme }) => theme.typography.baseStrong}
  fill: ${({ theme }) => theme.color.white};
`;

export const Postfix = styled('text')`
  ${({ theme }) => theme.typography.tiny}
  fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
`;
